import {
  GET_REPORT_ERROR_REQUEST,
  GET_REPORT_ERROR_SUCCESS,
  GET_REPORT_ERROR_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    error: false,
  };
};

const initialState = getInitialState();

const reportErrorModal = (state = initialState, action) => {
  const types = {
    [GET_REPORT_ERROR_REQUEST]: () => ({
      ...state,
      isLoading: true,
      error: false,
    }),
    [GET_REPORT_ERROR_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
    }),
    [GET_REPORT_ERROR_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default reportErrorModal;
